module.exports = __webpack_public_path__ + "fonts/cddac65.eot";